import RoomsBlock from './RoomsBlock.vue';

export * from './types';
export default RoomsBlock;



// WEBPACK FOOTER //
// ./src/pages/profile/components/info/components/block/components/legend/components/roomsblock/index.ts